export enum Role {
	superuser = 'superuser',
	support = 'support',
	partner = 'partner',
	customer = 'customer',
	service = 'service',
}

export const ROLE_HIERARCHY: Role[] = [
	Role.customer,
	Role.partner,
	Role.service,
	Role.support,
	Role.superuser,
];
